import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointMobile } from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.space32,
  },

  title: {
    [BreakPointMobile]: {
      fontSize: "20px !important",
    },
  },

  description: {
    [BreakPointMobile]: {
      fontSize: "14px !important",
      padding: `0px ${theme.spacing.space16}px`,
    },
  },

  retailerSection: {
    display: "flex",
    gap: theme.spacing.space24,
    justifyContent: "center",
    alignItems: "center",
  },

  retailerButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 160,
    height: 80,
    padding: 0,
    backgroundColor: theme.colors.TextDefault,
    border: "none",
    borderRadius: theme.spacing.space8,
    cursor: "pointer",
    "&:hover": {
      background: "#ffffff !important",
    },
    "& img": {
      maxWidth: "100%",
      maxHeight: "100%",
    },

    [BreakPointMobile]: {
      width: 140,
      height: 48,
    },
  },

  selected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 2,
  },
}));
